<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="saveItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Gebruiker {{item.name}} (#{{item.id}})
                  <b-button type="button" @click.prevent="resendInvite" :disabled="resendInviteButtonDisabled" variant="secondary"class="pull-right">Uitnodiging versturen</b-button>
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <h5>Basisgegevens</h5>
                        <hr>
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name" :disabled="!editable"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Email">
                          <b-form-input type="email" required v-model="item.email" :disabled="!editable"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Rol">
                          <b-form-select v-model="item.role" :options="roleOptions" :disabled="!editable" required></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row v-if="item.role === 'p-campaign-manager'">
                      <b-col>
                        <b-form-group label="Provincies">
                          <multiselect edit v-model="item.provinces" :options="provinceOptions" :multiple="true"
                            :close-on-select="true" :searchable="true" :clear-on-select="false"
                            placeholder="Kies provincie(s)" label="text" track-by="value" :preselect-first="true" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row v-else-if="item.role !== 'admin'">
                      <b-col>
                        <b-form-group label="Gemeentes">
                          <multiselect edit v-model="item.municipalities" :options="municipalityOptions"
                            :multiple="item.role !== 'volunteer'" :close-on-select="true" :searchable="true" :clear-on-select="false"
                            placeholder="Kies gemeente(s)" label="text" track-by="value" :preselect-first="true" />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template slot="footer">
                  <div v-if="editable">
                    <b-button @click.prevent="cancelEdit" class="mr-3" variant="warning">Annuleren</b-button>
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Wijzigingen opslaan</b-button>
                  </div>
                  <div v-if="!editable">
                    <b-button type="button" @click.prevent="editable = true" variant="primary" class="mr-3 pull-right">Bewerken</b-button>
                  </div>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { updateData, getData, addData } from '../../api';
  import roles from '../../roles';

  export default {
    name: 'user',
    props: ['id'],
    data() {
      return {
        saveButtonDisabled: false,
        resendInviteButtonDisabled: false,
        editable: false,
        companyOptions: [],
        item: {},
        provinceOptions: [],
        municipalityOptions: [],
        roleOptions: roles,
      };
    },
    methods: {
      async getItem() {
        this.item = await getData('users/' + this.$route.params.id).then(
          (response) => response.data.data
        );
      },
      async getProvinceOptions() {
        this.provinceOptions = await getData('provinces').then(
          (response) => response.data.data
        );
      },
      async getMunicipalityOptions() {
        this.municipalityOptions = await getData('municipalities').then(
          (response) => response.data.data
        );
      },
      async saveItem() {
        this.saveButtonDisabled = true;
        const request = await updateData(
          'users/' + this.$route.params.id,
          {
            name: this.item.name,
            email: this.item.email,
            role: this.item.role,
            provinces: this.item.role === 'p-campaign-manager' ? this.item.provinces.map(a => a.value) : [],
            municipalities: this.item.role === 'campaign-manager' ? this.item.municipalities.map(a => a.value) : this.item.role === 'volunteer' ? [this.item.municipalities.value] : [],
          }
        );
        if (request.status === 200) {
          this.editable = false;
          this.saveButtonDisabled = false;
          await this.getItem();
        } else {
          this.editable = true;
          this.saveButtonDisabled = false;
        }
      },
      cancelEdit() {
        this.editable = false;
        this.getItem();
      },
      async resendInvite() {
        this.resendInviteButtonDisabled = true;
        const request = await addData('users/send-invite', {
          user_id: this.$route.params.id,
        });
        if (request.status === 200) {
          alert('Uitnodiging verstuurd');
        } else {
          alert('Er is iets misgegaan...');
          this.resendInviteButtonDisabled = false;
        }
      },
    },
    beforeMount() {
      this.getItem();
      this.getMunicipalityOptions();
      this.getProvinceOptions();
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
